const queryGet = (paramKey: string, fallback: any = ""): string => {
  const params = new URLSearchParams(window.location.search);
  return params.get(paramKey) || fallback;
};

export default queryGet;
